import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function AlertDialogNote({children, main_message, message, ok, cancel, okFn, cancelFn, style}) {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <React.Fragment>
            <div onClick={handleClickOpen}>
                {children}
            </div>
            <Dialog
                style={style}
                open={open}
                PaperProps={{
                    style: {
                        maxWidth: '90vw', // например, не более 90% экрана
                    }
                }}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {main_message}
                </DialogTitle>
                { message ?
                <DialogContent>
                        {message}
                </DialogContent>
                :''}
                <DialogActions>
                    <Button onClick={()=>{ handleClose(); cancelFn();} } autoFocus>
                        {cancel}
                    </Button>
                    <Button onClick={()=>{ handleClose(); okFn();} } autoFocus>
                        {ok}
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
